import { render, staticRenderFns } from "./pz-form.vue?vue&type=template&id=a6ea14de&"
import script from "./pz-form.vue?vue&type=script&lang=js&"
export * from "./pz-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/DEV/gitlab/lenox/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6ea14de')) {
      api.createRecord('a6ea14de', component.options)
    } else {
      api.reload('a6ea14de', component.options)
    }
    module.hot.accept("./pz-form.vue?vue&type=template&id=a6ea14de&", function () {
      api.rerender('a6ea14de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/personalize/components/pz-form.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ../assets/js/personalize/components/pz-form.vue
// module id = 82
// module chunks = 0